export const logoutPageUrl = "/logout";

// Used for redirection after login. Can be customized by Okta admin
export const oktaRedirectUrl = "/login/callback";
export const oktaRedirectUrlLegacy = "/implicit/callback";
